const parseInteractableResponses = (newInteractable, interactablesArray) => {
  const parsed = interactablesArray
    .map(inter => {
      if (inter.id === newInteractable.id) {
        return newInteractable;
      } else {
        return newInteractable.primary ? { ...inter, primary: false } : inter;
      }
    })
    .sort((a, b) => {
      if (a.primary > b.primary) {
        return -1;
      }

      if (a.primary < b.primary) {
        return 1;
      }

      if (a.id < b.id) {
        return -1;
      } else if (a.id > b.id) {
        return 1;
      } else {
        return 0;
      }
    });

  return parsed;
};

export default parseInteractableResponses;
